import { Badge, Button, Tooltip } from '@mui/material';
import usePrintLabelContext from 'common/hooks/usePrintLabelContext';
import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listBulkLabelsByPage } from 'store/thunks/workQueueThunks';

import CentralFillSendDialog from './CentralFill/CentralFillSendDialog';

const BulkSendToCentralFillButton = () => {
  const { labelItemIds, clearLabelItems } = usePrintLabelContext();
  const dispatch = useDispatch();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // Snapshot the selection when the dialog opens, so it keeps its rows even
  // after we clear the live selection on a successful send.
  const [dialogLineItems, setDialogLineItems] = useState([]);

  const { pages, currentPage } = useSelector(({ workQueue }) => workQueue.bulkLabels);
  const bulkLabels = useMemo(() => pages[currentPage] || [], [pages, currentPage]);

  const selectedLineItems = useMemo(
    () => bulkLabels.filter((item) => labelItemIds.includes(item.lineItemId)),
    [bulkLabels, labelItemIds]
  );

  const isDisabled = isEmpty(selectedLineItems);
  const tooltipTitle = isDisabled ? 'Select one or more orders to send to compounding' : '';

  const handleOpen = () => {
    setDialogLineItems(selectedLineItems);
    setIsDialogOpen(true);
  };

  // After a successful send, drop the selection and reload so sent orders
  // disappear from the bulk queue.
  const handleConfirmed = () => {
    clearLabelItems();
    dispatch(listBulkLabelsByPage({ page: currentPage }));
  };

  return (
    <>
      <Tooltip title={tooltipTitle} arrow placement='top'>
        <span>
          <Badge color='error' badgeContent={selectedLineItems.length} sx={{ mx: 1 }}>
            <Button
              variant='contained'
              color='primary'
              onClick={handleOpen}
              disabled={isDisabled}
              sx={{ height: 33 }}
            >
              Send to Compounding
            </Button>
          </Badge>
        </span>
      </Tooltip>

      {isDialogOpen && (
        <CentralFillSendDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          lineItems={dialogLineItems}
          onConfirm={handleConfirmed}
        />
      )}
    </>
  );
};

export default BulkSendToCentralFillButton;
